import { GzLandingPageWebComponent } from './component/GzLandingPageWebComponent';

export { GzLandingPageWebComponent };
